module.exports = __webpack_public_path__ + "static/media/17992200_1834121553509166_3485332267004045014_n.d45d35fc.jpg";